<template>
	<div class="grid place-items-center mt-5 md:mt-20 text-center px-4">
		<h1 class="text-2xl md:text-4xl font-medium mb-4">We couldn't find the article you were looking for</h1>
		<p class="text-lg md:text-xl font-light mb-8">We suggest going to our search page to look for similar articles</p>
		<router-link to="/search" class="flex w-full sm:w-auto items-center justify-center gap-2 px-3 py-2 text-sm text-white bg-ch-red rounded-md hover:bg-ch-dark-red-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ch-red disabled:cursor-not-allowed">
      <font-awesome-icon  icon="fa-solid fa-magnifying-glass" />
      Go to Search
		</router-link>
	</div>
</template>

<script setup>
import { useHead } from '@unhead/vue'

useHead({
  title: 'Page Not Found',
})
</script>
